var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconHome(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21.76 19.98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".fill{fill:none;}.line{fill:#44444f;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fill"
  }, /*#__PURE__*/React.createElement("g", {
    id: "fill_wall"
  }, /*#__PURE__*/React.createElement("path", {
    className: "fill",
    d: "M11,1.6,3.5,5.7l1.7,12a1.1,1.1,0,0,0,1.2.8h9.3a1.1,1.1,0,0,0,1.2-.8l1.7-12ZM11,14a3.8,3.8,0,1,1,3.8-3.8A3.8,3.8,0,0,1,11,14Z",
    transform: "translate(-0.12 -0.02)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "fill",
    d: "M11,1.6,3.5,5.7l1.7,12a1.1,1.1,0,0,0,1.2.8h9.2a1.1,1.1,0,0,0,1.2-.8l1.7-12ZM11,14a3.8,3.8,0,1,1,3.8-3.8A3.8,3.8,0,0,1,11,14Z",
    transform: "translate(-0.12 -0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fill",
    d: "M21.5,5.6,11.4.1a.85.85,0,0,0-.7,0L.5,5.6a.78.78,0,0,0-.3,1A1,1,0,0,0,.9,7a.76.76,0,0,0,.4-.1l.8-.4L3.7,18a2.55,2.55,0,0,0,2.7,2h9.3a2.69,2.69,0,0,0,2.7-2.1L20,6.4l.8.4a.69.69,0,1,0,.7-1.2ZM16.8,17.7a1.1,1.1,0,0,1-1.2.8H6.4a1.1,1.1,0,0,1-1.2-.8L3.5,5.7,11,1.6l7.5,4.1Z",
    transform: "translate(-0.12 -0.02)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "line"
  }, /*#__PURE__*/React.createElement("g", {
    id: "line_window"
  }, /*#__PURE__*/React.createElement("path", {
    className: "line",
    d: "M11,6.4a3.8,3.8,0,1,0,3.8,3.8A3.8,3.8,0,0,0,11,6.4Zm0,6.1a2.3,2.3,0,1,1,2.3-2.3A2.33,2.33,0,0,1,11,12.5Z",
    transform: "translate(-0.12 -0.02)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "line",
    d: "M21.5,5.6,11.4.1a.85.85,0,0,0-.7,0L.5,5.6a.78.78,0,0,0-.3,1A1,1,0,0,0,.9,7a.76.76,0,0,0,.4-.1l.8-.4L3.7,18a2.55,2.55,0,0,0,2.7,2h9.3a2.69,2.69,0,0,0,2.7-2.1L20,6.4l.8.4a.69.69,0,1,0,.7-1.2ZM16.8,17.7a1.1,1.1,0,0,1-1.2.8H6.4a1.1,1.1,0,0,1-1.2-.8L3.5,5.7,11,1.6l7.5,4.1Z",
    transform: "translate(-0.12 -0.02)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHome);
export default __webpack_public_path__ + "static/media/icon_home.cd23a825145e8a6606bcb9061380d090.svg";
export { ForwardRef as ReactComponent };